// js
import { connect } from 'react-redux';
import KeyGoals from '../../../components/analytics/pptx/KeyGoals';
import { getGroupedKeyGoalsWithAnswersPPTX, getKeyGoalsCount } from '../../../selectors/analytics/goalsSelector';


const mapStateToProps = state => {
  return {
    groupedKeyGoalsWithAnswers: getGroupedKeyGoalsWithAnswersPPTX(state),
    keyGoalsCount: getKeyGoalsCount(state)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(KeyGoals);



// WEBPACK FOOTER //
// ./src/containers/analytics/pptx/KeyGoals.js